(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hurston-custom-jewelry"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hurston-process-video')) {
  customElements.define('hurston-process-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      this.initialized = true;
      if (!video.hasAttribute('aria-label')) video.setAttribute('aria-label', button.getAttribute('aria-label') || '');
      button.hidden = false;
      button.addEventListener('click', () => {
        button.hidden = true;
        video.play().then(() => video.focus()).catch(() => { button.hidden = false; });
      });
      video.addEventListener('play', () => { button.hidden = true; });
      video.addEventListener('ended', () => { button.hidden = false; });
      video.addEventListener('error', () => { button.hidden = false; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
